import React from 'react'
import { Grid } from '@material-ui/core'

import MainTemplate from '../../templates/MainTemplate'
import DailyMonitoringTemplate from '../../templates/DailyMonitoringTemplate'
import DateInfo from '../../containers/dailyMonitoring/details/main/DateInfo'
import MultipleShoppingCart from '../../containers/dailyMonitoring/details/multipleShoppingCart/Index'

const DailyMonitoringMultipleShoppingCart = (): JSX.Element => {
  return (
    <MainTemplate>
      <DailyMonitoringTemplate>
        <Grid item xs={12}>
          <DateInfo />
        </Grid>
        <MultipleShoppingCart />
      </DailyMonitoringTemplate>
    </MainTemplate>
  )
}

export default DailyMonitoringMultipleShoppingCart
